import { createFileRoute } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { DeliveryRecordSheet } from '@/features/orders/components/delivery-record-sheet'

function DeliveryPrintPage() {
  const { orderId } = Route.useParams()

  return (
    <Main>
      <DeliveryRecordSheet orderId={orderId} />
    </Main>
  )
}

export const Route = createFileRoute('/_authenticated/delivery-orders/print/$orderId')({
  component: DeliveryPrintPage,
})
